import { defineBulkAction } from '@juvare/platform-sdk-react/backend/features/bulk-actions';
import { getAlert, getAlerts, updateAlertAdditionalData } from '../../alertServiceClient';
import { migrateAlertsOrganizationCountBulkActionType } from './types';
export const migrateAlertsOrganizationCount = defineBulkAction({
    type: migrateAlertsOrganizationCountBulkActionType,
    onAuthRunSync: () => false,
    onAuthBulkAction: () => {
        throw Error('Migrate alerts should be called from backend');
    },
    onProcessBulkAction: (context, { updateProcessedCount, updateTotalCount }) => {
        var _a;
        const totalCount = getAlerts(context, createTokenRequest, { page: 0, size: 1 }).totalCount;
        console.log('Selected ' + totalCount + ' alerts');
        updateTotalCount(totalCount);
        const batchSize = 100;
        const fullChunks = Math.floor((totalCount - 1) / batchSize);
        let count = 0;
        // List all alerts
        for (let i = 0; i < fullChunks + 1; i++) {
            const alerts = getAlerts(context, createTokenRequest, { page: i, size: batchSize });
            for (const item of alerts.items) {
                const alert = getAlert(context, createTokenRequest, item.id, ['RECIPIENTS']);
                const statusLikeSent = alert.status && ['sent', 'sending', 'failed', 'archived'].includes(alert.status);
                count++;
                updateProcessedCount(count);
                // Checks if alert does not have additional data
                if ((_a = alert.additionalData) === null || _a === void 0 ? void 0 : _a.recipients) {
                    console.log(`Alert: ${alert.id} (${count}/${totalCount})`);
                    modifyAdditionalData(context, statusLikeSent, alert);
                }
            }
        }
    },
});
const createTokenRequest = {
    owners: [
        {
            externalId: '123456',
            name: 'Test',
            right: 'write',
            billingId: 'billingId',
        },
    ],
    userData: {
        displayName: 'System User',
        externalId: 'System User',
        allowWriteAll: true,
    },
};
function modifyAdditionalData(context, statusLikeSent, alert) {
    var _a, _b, _c, _d, _e;
    if (((_a = alert.additionalData) === null || _a === void 0 ? void 0 : _a.recipients) && typeof ((_b = alert.additionalData) === null || _b === void 0 ? void 0 : _b.recipients) === 'string') {
        const recipients = JSON.parse(alert.additionalData.recipients);
        if (!((_c = recipients.internal) === null || _c === void 0 ? void 0 : _c.organizations) || ((_d = recipients.internal) === null || _d === void 0 ? void 0 : _d.organizations.length) === 0) {
            return;
        }
        let finalCounts = recipients.finalCounts;
        const uniqueOrgIds = [...new Set((_e = recipients.internal) === null || _e === void 0 ? void 0 : _e.organizations)];
        if (statusLikeSent) {
            finalCounts = Object.assign(Object.assign({}, finalCounts), { organizationCount: uniqueOrgIds.length });
        }
        // Update alert additional data.
        const data = Object.assign(Object.assign({}, recipients), { internal: Object.assign(Object.assign({}, recipients.internal), { organizations: uniqueOrgIds }), finalCounts });
        updateAlertAdditionalData(context, createTokenRequest, alert.id, Object.assign(Object.assign({}, alert.additionalData), { recipients: JSON.stringify(data) }));
    }
}
